import { formatDuration } from "kinnect-formatters";

export default {
	name: "KTimeAgo",

	props: {
		active: {
			default: true,
			type: Boolean
		},
		includeSeconds: {
			default: true,
			type: Boolean
		},
		startTime: Number,
		short: {
			default: true,
			type: Boolean
		},
		tag: {
			default: "span",
			type: String
		},
		levels: {
			default: 2,
			type: Number
		}
	},

	data: () => ( {
		now: Date.now(),
		interval: null
	} ),

	computed: {
		diff() {
			return Math.abs( this.now - this.startTime );
		},

		timeStr() {
			return formatDuration( this.diff, this.includeSeconds, this.short, this.levels );
		}
	},

	watch: {
		active: {
			handler( val ) {
				if ( val ) {
					this.interval = setInterval( () => {
						this.now = Date.now();
					}, 1000 );
				} else {
					clearInterval( this.interval );
				}
			},
			immediate: true
		}
	},

	beforeDestroy() {
		clearInterval( this.interval );
	},

	render() {
		return <this.tag>{this.timeStr}</this.tag>;
	}
};
